"use strict";
/**
 * To add a new event:
 * 1) If it should accept arguments, add it to WEB_EVENT_WITH_ARGS.
 *    If not, add it to WEB_EVENT_WITH_NO_ARGS
 * 2) If it accepts arguments, add the type of its arguments to WebEventArgMapping
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEB_EVENT = exports.WEB_EVENT_WITH_NO_ARGS = exports.WEB_EVENT_WITH_ARGS = void 0;
var WEB_EVENT_WITH_ARGS;
(function (WEB_EVENT_WITH_ARGS) {
    WEB_EVENT_WITH_ARGS["INVOKE_CUSTOM_WEBVIEW"] = "INVOKE_CUSTOM_WEBVIEW";
    WEB_EVENT_WITH_ARGS["INVOKE_EXTERNAL_URL"] = "INVOKE_EXTERNAL_URL";
    WEB_EVENT_WITH_ARGS["INVOKE_INTERNAL_URL"] = "INVOKE_INTERNAL_URL";
    WEB_EVENT_WITH_ARGS["INVOKE_NATIVE_SHARE"] = "INVOKE_NATIVE_SHARE";
    WEB_EVENT_WITH_ARGS["INVOKE_PDF_LAUNCH"] = "INVOKE_PDF_LAUNCH";
    WEB_EVENT_WITH_ARGS["PHONE"] = "INVOKE_PHONE";
    WEB_EVENT_WITH_ARGS["INVOKE_SET_DISMISS"] = "INVOKE_SET_DISMISS";
    WEB_EVENT_WITH_ARGS["INVOKE_MODAL_WEBVIEW"] = "INVOKE_MODAL_WEBVIEW";
    WEB_EVENT_WITH_ARGS["INVOKE_SUCCESS_ACTION"] = "INVOKE_SUCCESS_ACTION";
    WEB_EVENT_WITH_ARGS["INVOKE_PARENT_REFRESH"] = "INVOKE_PARENT_REFRESH";
})(WEB_EVENT_WITH_ARGS = exports.WEB_EVENT_WITH_ARGS || (exports.WEB_EVENT_WITH_ARGS = {}));
var WEB_EVENT_WITH_NO_ARGS;
(function (WEB_EVENT_WITH_NO_ARGS) {
    WEB_EVENT_WITH_NO_ARGS["INVOKE_DASHBOARD_REFRESH"] = "INVOKE_DASHBOARD_REFRESH";
    WEB_EVENT_WITH_NO_ARGS["INVOKE_DISMISS_ALL"] = "INVOKE_DISMISS_ALL";
    WEB_EVENT_WITH_NO_ARGS["INVOKE_DISMISS_THIS"] = "INVOKE_DISMISS_THIS";
    WEB_EVENT_WITH_NO_ARGS["INVOKE_GET_LOCATION"] = "INVOKE_GET_LOCATION";
    WEB_EVENT_WITH_NO_ARGS["INVOKE_LOGIN_NAVIGATE"] = "INVOKE_LOGIN_NAVIGATE";
    WEB_EVENT_WITH_NO_ARGS["REQUEST_TOKEN"] = "INVOKE_REQUEST_TOKEN";
    WEB_EVENT_WITH_NO_ARGS["INVOKE_SUPPORT_FORM"] = "INVOKE_SUPPORT_FORM";
})(WEB_EVENT_WITH_NO_ARGS = exports.WEB_EVENT_WITH_NO_ARGS || (exports.WEB_EVENT_WITH_NO_ARGS = {}));
exports.WEB_EVENT = Object.assign(Object.assign({}, WEB_EVENT_WITH_ARGS), WEB_EVENT_WITH_NO_ARGS);
//# sourceMappingURL=web-events.js.map